<!-- 智慧场景管理 -->

<template>
  <div class="c-profile-content">
    <ul class="c-profile-list c-binding-list">
      <li>
        <p class="c-profile-lf-txt"><em>*</em>标题</p>
        <div class="c-profile-rt-input">
          <input v-model="title" type="text" placeholder="标题">
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>领域</p>
      </li>
      <li>
        <!-- <p class="c-profile-lf-txt">领域</p> -->
        <!-- <div class="c-profile-rt-input">
                  <select  v-model="industryCategory">
                    <option value ="新基建">新基建</option>
                    <option value ="数字上云">数字上云</option>
                    <option value ="智慧专区">智慧专区</option>
                    <option value ="其他">其他</option>
                  </select>
                  <input style="float: right;" placeholder="请输入服务领域" v-show="showIndustryCategoryOther" type="text" v-model="industryCategoryOther">
              </div> -->
        <NewConstructor :selectedOptions="industryCategory" v-on:dataChange="handleNewConstructorChange" />

      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>视频描述</p>
        <div class="c-profile-rt-input">
          <textarea v-model="profile" placeholder="内容描述限制在15-30个字符"></textarea>
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>视频封面</p>
        <div class="c-profile-rt-input">
          <div class="img-list">
            <!-- <img v-for="(img, index) in imgPreviews" :key="index" :src="img">
                      <div v-if="!imgPreviews.length" class="file-btn">
                          <img src="../../assets/main/failbg.png">
                          <Upload v-if="imgPreviews.length < 5" class="file-btn__upload" accept="image/png, image/jpeg" v-on:resetImageName="resetImageName" btnText="上传配图" >
                            <span class="file-btn__upload-btn"></span>
                          </Upload>
                      </div> -->



            <ul class='coverlist'>
                <li  v-for="(item, index) in covers" :key=index @click="selcover(item)">
                  <div>
                    <img :src="item">
                  </div>
                </li>
            </ul>
          </div>
          <!-- <div class="c-profile-rt-input">
            <a :href="downloadZipPath"><span class="download-agreement download-agreement2" style="padding-left:0;">下载物料包<img
                  src="../../assets/main/xiazai.png"></span></a>
          </div> -->
          <div class="c-profile-rt-input">
            <p class="c-tips3">请选择一张封面图</p>
          </div>
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>视频链接</p>
        <div class="c-profile-rt-input">
          <input v-model="uri" type="text" placeholder="请输入视频链接">
          <div class="price-negotiation">
            <input class="product-pricing checkbox" v-model="isRedirect" id="isRedirect" type="checkbox" value=""><label
              for="isRedirect">跳转外部播放</label>
          </div>
        </div>
      </li>
      <li>
        <p class="c-tips3">请提供产品或服务应用场景视频，不要提供企业宣传视频。</p>
        <p class="c-tips3">如果需要外部播放，请勾选跳转外部播放。</p>
      </li>
    </ul>

    <div class="sbumit-btn-box">
      <button @click="onVideoCreate" class="submit-btn">提交</button>
      <button @click="backOrg" class="submit-btn cancel-btn">取消</button>
    </div>
  </div>
</template>

<script>
  import {
    addVideo,
    modifyVideo,
    getVideoById,
  } from '@/api/video';
  import Upload from '@/components/common/Upload';
  import config from '@/config/index';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import NewConstructor from './components/NewConstructor'
  export default {
    name: 'SceneManager',
    props: {
      msg: String,
    },
    components: {
      Upload,
      NewConstructor
    },
    data() {
      return {
        covers:['http://img.yunsmartcity.com/assets/covers/cover1.jpg','http://img.yunsmartcity.com/assets/covers/cover2.jpg','http://img.yunsmartcity.com/assets/covers/cover3.jpg','http://img.yunsmartcity.com/assets/covers/cover4.jpg'],
        downloadZipPath: 'http://img.yunsmartcity.com/asset/%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2%E6%A8%A1%E6%9D%BF.zip',
        videoInfo: {},
        vid: '',
        title: '', //            标题
        orgid: '', //            所属机构
        uploadUid: '', //        上传者
        industryCategory: '', // 分类
        industryCategoryOther: '', // 分类
        tags: '', //             标签
        profile: '', //          简介
        contacts: '', //         联系人
        mobile: '', //           手机号
        cover: '', //            封面
        uri: '', //              视频地址
        isRedirect: 0, //       是否跳转
        redirectUri: '', //      跳转地址
        show: 0, //             是否显示
        imgKeys: [],
        imgPreviews: [],
        checkedNewConstructors: [],
        seletCover:'assets/covers/cover1.jpg'
      }
    },
    computed: {
      showIndustryCategoryOther() {
        return this.industryCategory === '其他';
      },
    },
    mounted() {
      this.orgid = this.$route.query.orgid;
      this.vid = this.$route.query.vid;
      this.queryInfo(this.vid);
    },
    methods: {
      selcover(item){
        this.seletCover = item
      },
      queryInfo(vid) {
        if (!vid) return;
        this.$http.get(getVideoById(vid)).then((res) => {
          if (res.code === 1) {
            console.log(res);
            this.videoInfo = res.data;
            this.initData();
          }
        });
      },
      initData() {
        if (this.videoInfo) {
          const keys = Object.keys(this.videoInfo);
          keys.forEach((key) => {
            this[key] = this.videoInfo[key];
          });
          if (this.cover && typeof this.cover === 'string') {
            // let imgs = JSON.parse(this.cover);
            // this.imgKeys = imgs;
            // if (imgs && imgs.length > 0) {
            //     imgs = imgs.map((img) => {
            //         return `${config.HOST_IMG}${img}`;
            //     });
            // }
            // this.imgPreviews = imgs;
            this.imgPreviews = [`${config.HOST_IMG}${this.cover}`]
          }
          this.priceDiscuss = this.nonamount === 1;
        }
      },
      resetImageName(key) {
        this.imgKeys.push(key);
        this.imgPreviews.push(`${config.HOST_IMG}${key}`);
      },
      getParams() {
        return {
          vid: this.vid,
          title: this.title, //            标题
          orgid: this.orgid, //            所属机构
          uploadUid: this.uploadUid, //        上传者
          industryCategory: this.industryCategory === '其他' ? this.industryCategoryOther : this.industryCategory,
          tags: this.tags, //             标签
          profile: this.profile, //          简介
          contacts: this.contacts, //         联系人
          mobile: this.mobile, //           手机号
          cover: this.seletCover.split('com/')[1],//this.imgKeys, //JSON.stringify(this.imgKeys),//            封面
          uri: this.uri, //              视频地址
          isRedirect: this.isRedirect ? 1 : 0, //       是否跳转
          redirectUri: this.redirectUri, //      跳转地址
          show: 0, //             是否显示
          uploadUid: getCacheUserInfo().uid,
        }
      },
      onVideoCreate() {
        const params = this.getParams();
        if (this.vid) {
          this.$http.post(modifyVideo(), params, {
            uid: getCacheUserInfo().uid
          }).then(res => {
            console.log(res);
            if (res.code === 1) {
              this.$router.push('org');
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          this.$http.post(addVideo(), params, {
            uid: getCacheUserInfo().uid
          }).then(res => {
            console.log(res);
            if (res.code === 1) {
              this.$router.push('org');
            } else {
              this.$message.warning(res.msg);
            }
          });
        }

      },
      backOrg() {
        this.$router.push('org?hasData=true');
      },
      getCheckedCategories() {
        return this.checkedNewConstructors
      },
      handleNewConstructorChange(param) {
        console.log("handleNewConstructorChange", param)
        this.industryCategory = param
      },
    }
  };
</script>

<style>
  @import url(./main.css);

  .file-btn {
    position: relative;
  }

  .file-btn__upload {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
  }

  .file-btn__upload-btn {
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
  }
.coverlist{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.coverlist li{
  width: 20%;
  height: 150px;
  margin-top: 5px;
  /* padding: 2px; */
}
.coverlist li:not(:nth-child(4n)) {
  margin-right: 5%;
}
.coverlist li img {
    box-sizing: border-box;
    width: 100%;
}
.coverlist li img:hover, .coverlist li img.active {
  border: solid 1px #267FF2;
  cursor: pointer;
}


</style>
